import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';
import { Label } from '@cian/ui-kit';
import { IconFunctionalSuccess12 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

export const GalleryLabelsContainer: FC = () => {
  const { id } = useCardOfferContext();

  const { isOfferVisited } = useVisitedOffersContext();

  if (!isOfferVisited(id)) {
    return null;
  }

  return (
    <Label
      background="overlay-default"
      color="text-inverted-default"
      icon={<IconFunctionalSuccess12 color="text-inverted-default" />}
    >
      Вы смотрели
    </Label>
  );
};
